import { PROFILE_IMAGE_UPLOAD, UPDATE_PROFILE } from './ApiConstants';
import api from './ApiHandler';

interface profilepayload {
  name: string;
  mobile: string;
  email: string;
  defaultLanguage: string;
}

export const editProfile = async (payload: profilepayload) => {
  return await api.post(UPDATE_PROFILE, { ...payload });
};

export const uploadProfileImg = async (payload: any) => {
  return await api.post(PROFILE_IMAGE_UPLOAD, payload, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};
